<app-dialog class="notification-dialog" [hideClose]="hideClose">
  <ng-container dialog-content>
    <div *ngIf="title" class="title">
      {{ title }}
    </div>
    <div class="close" *ngIf="closeButton">
      <span class="fa fa-times" (click)="decline()"></span>
    </div>
    <div
      class="description-container"
      [class.desc-row]="orientation === DialogOrientation.row"
      [class.desc-column]="orientation === DialogOrientation.column"
    >
      <div
        [ngClass]="iconDescriptionAlign ? 'icon-description-align' : 'description-icon'"
        [class.flex]="orientation === DialogOrientation.column"
      >
        <span
          *ngIf="descriptionFaClass"
          class="fa"
          [ngClass]="descriptionFaClass"
          [style.color]="descriptionFaColor"
        ></span>
      </div>
      <div class="description-text" [innerHTML]="descriptionText"></div>
    </div>
    <div
      class="button-container"
      *ngIf="confirmText || declineText"
      [class.btn-center]="buttonAlignment === DialogButtonAlignment.center"
      [class.btn-end]="buttonAlignment === DialogButtonAlignment.end"
    >
      <button
        *ngIf="declineText"
        class="btn btn-outline-secondary decline-btn"
        (click)="decline($event)"
      >
        <span
          *ngIf="declineFaClass"
          class="fa decline-icon"
          [ngClass]="declineFaClass"
          [style.color]="declineFaColor"
        ></span>
        {{ declineText }}
      </button>
      <button
        *ngIf="confirmText"
        class="btn btn-outline-primary confirm-btn"
        (click)="confirm($event)"
      >
        <span
          *ngIf="confirmFaClass"
          class="fa confirm-icon"
          [ngClass]="confirmFaClass"
          [style.color]="confirmFaColor"
        ></span>
        {{ confirmText }}
      </button>
    </div>
  </ng-container>
</app-dialog>
